import { jsxs as H, jsx as C } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as l } from "./index.es2359.js";
function i({ size: V = l }) {
  return /* @__PURE__ */ H(
    "svg",
    {
      width: V,
      height: V,
      viewBox: "0 0 56 57",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C("rect", { y: "0.936646", width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M25.5 17.9366H21.7228C21.0474 17.9366 20.5 18.5152 20.5 19.2279V19.8683H25.5V17.9366Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M35.5 17.9366H31.7228C31.0474 17.9366 30.5 18.5152 30.5 19.2279V19.8683H35.5V17.9366Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M24.4648 24.0936C25.2141 24.0936 25.8685 24.4779 26.2217 25.0497C26.3746 24.9771 26.5443 24.9366 26.7228 24.9366H29.8541C30.2207 24.4278 30.8371 24.0936 31.5352 24.0936H34.4648C35.5893 24.0936 36.5 24.959 36.5 26.0253V31.3915C36.5 31.9438 36.0523 32.3915 35.5 32.3915H31.3879C31.4605 32.5901 31.5 32.8033 31.5 33.0253V36.3915H24.5V33.0253C24.5 32.8033 24.5395 32.5901 24.6122 32.3915H20.5C19.9477 32.3915 19.5 31.9438 19.5 31.3915V26.0253C19.5 24.959 20.4118 24.0936 21.5352 24.0936H24.4648ZM25.5 26.8683H30.5V29.0432C30.5 30.4523 29.4088 31.6055 28.0745 31.6055H27.9246C26.5912 31.6055 25.5 30.4523 25.5 29.0432V26.8683Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M20.5 19.8683V22.0432C20.5 22.8797 20.8845 23.626 21.476 24.0944C21.4957 24.0939 21.5154 24.0936 21.5352 24.0936H24.4648C24.4845 24.0936 24.5042 24.0939 24.5238 24.0944C25.1155 23.626 25.5 22.8797 25.5 22.0432V19.8683H20.5Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M34.5238 24.0944C34.5042 24.0939 34.4845 24.0936 34.4648 24.0936H31.5352C31.5154 24.0936 31.4957 24.0939 31.476 24.0944C30.8845 23.626 30.5 22.8797 30.5 22.0432V19.8683H35.5V22.0432C35.5 22.8797 35.1155 23.626 34.5238 24.0944Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M30.5 26.8683H25.5V29.0432C25.5 30.4523 26.5912 31.6055 27.9246 31.6055H28.0745C29.4088 31.6055 30.5 30.4523 30.5 29.0432V26.8683Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M19.5 28.6401V31.3915C19.5 31.9438 19.9477 32.3915 20.5 32.3915H24.6122C24.5395 32.5901 24.5 32.8033 24.5 33.0253V36.3915H31.5V33.0253C31.5 32.8033 31.4605 32.5901 31.3879 32.3915H35.5C36.0523 32.3915 36.5 31.9438 36.5 31.3915V28.6401C39.2561 29.9237 41 31.8205 41 33.9366C41 37.8026 35.1797 40.9366 28 40.9366C20.8203 40.9366 15 37.8026 15 33.9366C15 31.8205 16.7439 29.9237 19.5 28.6401Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.7228 17.4366C20.7459 17.4366 20 18.2652 20 19.2279V22.0432C20 22.6878 20.1947 23.2938 20.5287 23.7939C19.6382 24.1643 19 25.0118 19 26.0253V28.8853C16.5347 30.1593 15 31.9514 15 33.9366C15 37.8026 20.8203 40.9366 28 40.9366C35.1797 40.9366 41 37.8026 41 33.9366C41 31.9514 39.4654 30.1593 37.0001 28.8854V26.0253C37.0001 25.0118 36.3623 24.164 35.4714 23.7937C35.8054 23.2937 36.0001 22.6877 36.0001 22.0432V17.4366H31.7229C30.7459 17.4366 30.0001 18.2652 30.0001 19.2279V22.0432C30.0001 22.6878 30.1947 23.2938 30.5287 23.7939C30.1771 23.9401 29.8649 24.1608 29.6157 24.4366H26.7228C26.6157 24.4366 26.5113 24.4466 26.4105 24.4656C26.1572 24.1761 25.8354 23.9451 25.4714 23.7937C25.8054 23.2937 26 22.6877 26 22.0432V17.4366H21.7228ZM25.4989 24.9672C25.2767 24.7772 24.9929 24.6464 24.6728 24.6065C24.2156 24.9209 23.6678 25.1055 23.0745 25.1055H22.9246C22.3316 25.1055 21.7841 24.9209 21.327 24.6066C20.5597 24.7025 20 25.3217 20 26.0253V31.3916C20 31.6677 20.2239 31.8916 20.5 31.8916H24.291C24.5611 31.4011 25.0005 31.0136 25.5287 30.7939C25.1947 30.2938 25 29.6878 25 29.0432V26.2279C25 25.7446 25.188 25.295 25.4989 24.9672ZM24.0037 32.8916H20.5C19.6716 32.8916 19 32.22 19 31.3916V30.0241C16.971 31.1914 16 32.6078 16 33.9366C16 35.3254 17.0608 36.8099 19.2817 38.0058C21.4619 39.1798 24.5425 39.9366 28 39.9366C31.4575 39.9366 34.5381 39.1798 36.7183 38.0058C38.9392 36.8099 40 35.3254 40 33.9366C40 32.6078 39.029 31.1915 37.0001 30.0241V31.3916C37.0001 32.22 36.3285 32.8916 35.5001 32.8916H31.9963C31.9987 32.9358 32 32.9804 32 33.0253V36.3916C32 36.6677 31.7761 36.8916 31.5 36.8916H24.5C24.2239 36.8916 24 36.6677 24 36.3916V33.0253C24 32.9804 24.0013 32.9358 24.0037 32.8916ZM21 20.3683H25V22.0432C25 23.2024 24.1071 24.1055 23.0745 24.1055H22.9246C21.893 24.1055 21 23.2026 21 22.0432V20.3683ZM21 19.2279C21 18.7652 21.349 18.4366 21.7228 18.4366H25V19.3683H21V19.2279ZM31 29.0432V24.6825C31.1037 24.6466 31.2131 24.6208 31.3271 24.6066C31.7841 24.9209 32.3317 25.1055 32.9247 25.1055H33.0745C33.6679 25.1055 34.2156 24.9209 34.6728 24.6065C35.4409 24.7023 36.0001 25.3214 36.0001 26.0253V31.3916C36.0001 31.6677 35.7762 31.8916 35.5001 31.8916H31.7092C31.4392 31.401 30.9998 31.0134 30.4714 30.7937C30.8054 30.2937 31 29.6877 31 29.0432ZM31.0001 20.3683H35.0001V22.0432C35.0001 23.2024 34.1072 24.1055 33.0745 24.1055H32.9247C31.8931 24.1055 31.0001 23.2026 31.0001 22.0432V20.3683ZM31.0001 19.2279C31.0001 18.7652 31.3491 18.4366 31.7229 18.4366H35.0001V19.3683H31.0001V19.2279ZM26.327 31.6066C25.5597 31.7025 25 32.3217 25 33.0253V35.8916H31V33.0253C31 32.3214 30.4409 31.7023 29.6728 31.6065C29.2156 31.9209 28.6678 32.1055 28.0745 32.1055H27.9246C27.3316 32.1055 26.7841 31.9209 26.327 31.6066ZM30 27.3683H26V29.0432C26 30.2026 26.893 31.1055 27.9246 31.1055H28.0745C29.1071 31.1055 30 30.2024 30 29.0432V27.3683ZM26.7228 25.4366C26.349 25.4366 26 25.7652 26 26.2279V26.3683H30V25.4366H26.7228Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
i.__tags = [];
export {
  i as MetricPopulationDensityIcon
};
//# sourceMappingURL=index.es401.js.map
